/**
 * English strings. Same keys as es.js — if a key is missing here, vue-i18n
 * falls back to Spanish, so a forgotten translation shows the Spanish text
 * instead of an empty label or a raw key.
 */
export default {
  comun: {
    todas: 'All',
    cancelar: 'Cancel',
    guardar: 'Save',
    guardando: 'Saving…',
    siguiente: 'Next',
    borrar: 'Delete',
    agregar: 'Add',
    enviar: 'Send',
    cargando: 'Loading…',
    buscar: 'Search ...',
    limpiar: 'Clear',
    telefono: 'Phone',
    correo: 'Email',
    nombre: 'First name',
    apellido: 'Last name',
    etapa: 'Stage',
    idioma: 'Language',
    sinDeshacer: 'This action cannot be undone.',
    seguro: 'Are you sure you want to delete this?',
    si: 'Yes',
    acciones: 'Actions',
    volver: 'Go back',
    deTotal: '{desde}-{hasta} of {total}',
  },

  formularios: {
    titulo: 'Forms',
    contador: 'forms',
    agregarNuevo: '+ New form',
    colTitulo: 'Title',
    colSubtitulo: 'Subtitle',
    colUrl: 'Link',
    enlaceCopiado: 'Link copied',
    tituloModal: 'Form details',
    phTitulo: 'Enter a title',
    phSubtitulo: 'Enter a subtitle',
    landingPropia: 'Your own landing page (HTML) — optional',
    phLanding: 'Paste your landing page HTML here',
    ayudaLanding: 'Paste your landing page code. {sinFormulario}: we add it ourselves so the details reach your board. If you want to choose where it shows up, put {etiqueta} wherever you prefer; otherwise it goes at the end.',
    ayudaLandingSinFormulario: 'Do not include a form',
    paginaGracias: 'Thank-you page (URL) — optional',
    mensajeAlEnviar: 'Message after sending — optional',
    phMensajeGracias: 'Thank you! We will contact you shortly.',
    seleccionarArchivo: 'Select file',
    examinar: 'Browse',
    vistaPrevia: 'Preview',
    actualizarFormulario: 'Update form',
    agregarFormulario: 'Add form',
    pideTitulo: 'Please enter a title',
    pideSubtitulo: 'Please enter a subtitle',
    archivoSubido: '{archivo}: file uploaded.',
    archivoFallo: '{archivo}: upload failed.',
  },

  formPublico: {
    dejanosTusDatos: 'Leave us your details',
    enviar: 'Send',
    enviando: 'Sending…',
    completaTodo: 'Please fill in every field.',
    gracias: 'Thank you! We will contact you shortly.',
    errorEnviar: 'It could not be sent. Check the details and try again.',
  },

  menu: {
    aplicaciones: 'APPLICATIONS',
    administracion: 'Administration',
    panel: 'Dashboard',
    roles: 'Roles',
    usuarios: 'Users',
    paquetes: 'Packages',
    contactos: 'Contacts',
    oportunidades: 'Opportunities',
    notas: 'Notes',
    formularios: 'Forms',
    tickets: 'Tickets',
    campanas: 'Campaigns',
    conversaciones: 'Conversations',
    clientesYCanales: 'Clients and channels',
  },

  bandeja: {
    titulo: 'Conversations',
    elegirConversacion: 'Select a conversation to see the messages.',
    equipo: 'Team',
    mias: 'Mine',
    sinAsignar: 'Unassigned',
    abiertas: 'Open',
    resueltas: 'Resolved',
    todosLosCanales: 'All channels',
    escribeRespuesta: 'Write a reply…',
    nombreDelContacto: 'Contact name',
    alEmbudo: 'Add to the Opportunities board',
    agregadoAlEmbudo: 'Added to the board',
    atiende: 'Handled by',
    tomarla: 'Take it',
    canalCaidoTitulo: '{canal} is disconnected',
    canalCaidoDetalle: 'New messages are not coming in through it. Contact your administrator to reconnect it.',
    canalesCaidosTitulo: '{n} channels are disconnected',
    canalesCaidosDetalle: 'New messages are not coming in through {canales}. Contact your administrator to reconnect them.',
    canalEmail: 'Email',
    canalOtro: 'Other',
    vacioTodas: 'No conversations yet.',
    vacioMias: 'You have no conversations assigned.',
    vacioSinAsignar: 'There are no unassigned conversations.',
    errorLista: 'Could not load the conversations.',
    errorMensajes: 'Could not load the messages.',
    errorEnviar: 'Could not send the message.',
    errorAsignar: 'Could not assign it.',
    errorNombre: 'Could not save the name.',
    errorEmbudo: 'Could not add it to the board.',
    escribeNombre: 'Please type a name.',
    avisosSinSoporte: 'This browser does not support desktop notifications.',
    avisosBloqueados: 'Notifications were blocked in the browser.',
    activarAvisos: 'Enable alerts',
    editar: 'Edit',
    ponerNombre: 'Set a name',
    creando: 'Creating…',
    enviando: 'Sending…',
    botonEmbudo: '+ To board',
    sinNombre: 'No name',
    nadie: 'nobody',
    yo: 'me',
    avisosListos: 'Done: we will notify you even from another tab.',
    nombreGuardado: 'Name saved.',
    noEstaEnLaLista: 'That conversation is not in the current list. Try switching the filter to “All”.',
    teAsignaron: 'A chat was assigned to you',
    contactoGenerico: 'Contact',
    elContacto: 'The contact',
    agregadoAlEmbudoDetalle: '{nombre} is now in Opportunities, in the first stage.',
    chatNuevo: 'New chat',
  },

  equipo: {
    tituloModal: 'WhatsApp team',
    ayuda: 'The people you add here sign in to this same CRM with their own email and password, see this inbox and reply under their own name.',
    cupo: 'Your plan includes {personas}, counting yourself.',
    nPersonas: '{n} people',
    puedesAgregar: 'You can add {n} more.',
    yaLasUsaste: 'You have used them all.',
    colPersona: 'Person',
    colAcceso: 'Access',
    yaEntro: 'Signed in',
    sinEntrar: 'Not yet signed in',
    quitar: 'Remove',
    siNadieContesta: 'If nobody replies',
    ayudaEscalado: 'Passes the chat to the next person on the list after it has gone that many minutes without a reply. Once it has been round everyone, it leaves it in {sinAsignar} so the whole team can see it.',
    minutosSinRespuesta: 'Minutes without a reply (empty = off)',
    zonaHoraria: 'Time zone',
    diasDeAtencion: 'Working days',
    desde: 'From',
    hasta: 'To',
    lun: 'Mon',
    mar: 'Tue',
    mie: 'Wed',
    jue: 'Thu',
    vie: 'Fri',
    sab: 'Sat',
    dom: 'Sun',
    notaClave: 'You set the initial password, so you know it. Ask each person to change it in {perfil} the first time they sign in.',
    perfilCambiarClave: 'Profile → change password',
    agregarPersona: '+ Add person',
    notaCupoLleno: 'To add someone else, message your administrator: it is $15 a month per person.',
    correoConEntra: 'Email (the one they will sign in with)',
    claveMinimo8: 'Password (at least 8 characters)',
    agregando: 'Adding…',
    escaladoListo: 'Done: if nobody replies within {n} min, the chat moves to the next person.',
    escaladoApagado: 'Escalation turned off.',
    errorGuardar: 'Could not save.',
    errorCargarEquipo: 'Could not load the team.',
    personaAgregada: 'Person added',
    personaAgregadaDetalle: 'They can now sign in at app.crmproyectx.com with {correo} and the password you just set. Ask them to change it in Profile once inside.',
    errorAgregar: 'Could not add them.',
    quitarDelEquipo: 'Remove from the team',
    quitarDetalle: '{nombre} will no longer be able to sign in to the CRM or see this inbox. The messages they already sent are kept under their name.',
    personaQuitada: 'Person removed from the team.',
    errorQuitar: 'Could not remove them.',
  },

  canal: {
    tituloSinCanales: 'Channels',
    sinCanales: 'You have no channels connected yet',
    conectaFacebook: 'Connect your Facebook Page and answer its messages from here, alongside your other channels.',
    avisoSinActivar: 'To activate the WhatsApp inbox for your account, contact your administrator. The support team sets up your number and your conversations will show up here.',
    conectadoAl: 'Connected to number {numero}',
    conectaTuNumero: 'Connect your WhatsApp number to receive and answer messages',
    numeroDeWhatsapp: 'WhatsApp number',
    pideAccountSid: 'Enter the Account SID',
    pideAuthToken: 'Enter the Auth Token',
    pideNumero: 'Enter the number',
    seGuardaCifrado: 'Stored encrypted; it is never shown again',
    actualizarConexion: 'Update connection',
    conectarWhatsapp: 'Connect WhatsApp',
    desconectar: 'Disconnect',
    conectado: 'WhatsApp connected successfully.',
    desconectado: 'WhatsApp disconnected.',
    errorGuardar: 'Could not save. Check the details.',
    errorDesconectar: 'Could not disconnect.',
  },

  clientes: {
    titulo: 'Client WhatsApp accounts',
    contador: 'clients',
    buscarCliente: 'Search client ...',
    ayuda: 'Each client has their own WhatsApp account, isolated from everyone else. First you create the account, then you connect their number.',
    colCliente: 'Client',
    colCuenta: 'WhatsApp account',
    colNumero: 'Number',
    sinNombre: '(no name)',
    cuentaCreada: 'Account created (#{n})',
    sinCuenta: 'No account',
    enlazado: 'Linked',
    faltaEnlazar: 'Inbox not linked yet',
    sinNumero: 'No number',
    crearCuenta: 'Create account',
    cambiarNumero: 'Change number',
    conectarNumero: 'Connect number',
    marca: 'Branding',
    marcaDe: 'Branding for {nombre}',
    ayudaMarca: 'The client and their team will see this logo and name inside the CRM instead of ours. The sign-in screen does not change.',
    phNegocio: 'Example Clinic',
    campoLogo: 'Logo (PNG or JPG, 1 MB max)',
    logoActual: 'Current logo:',
    guardarMarca: 'Save branding',
    volverMarcaCrm: 'Back to the CRM branding',
    volverMarcaCrmDetalle: '{nombre} will see the CRM ProyectX logo and name again.',
    quitarMarca: 'Remove branding',
    marcaGuardada: 'Branding saved. The client will see it after a refresh.',
    marcaQuitada: 'Branding removed.',
    conectarWhatsappDe: 'Connect WhatsApp for {nombre}',
    ayudaEnlace: 'The inbox links itself only if one already exists with this same number.',
    guardarConexion: 'Save connection',
    numeroConectado: 'Number connected.',
    cuentaCreadaAviso: 'Account created.',
    reenlazarTitulo: 'The number has to be linked again',
    reenlazarDetalle: 'This client was on the shared account. Create their inbox in their new account and save the number here again.',
    desconectarTitulo: 'Disconnect WhatsApp',
    desconectarDetalle: 'Client {nombre} will no longer see their inbox. It can be connected again later.',
    errorCargar: 'Could not load the client list.',
    errorCrearCuenta: 'Could not create the account.',
    errorGuardarMarca: 'Could not save the branding.',
    errorQuitarMarca: 'Could not remove the branding.',
  },

  embudo: {
    titulo: 'Opportunities',
    configurarEtapas: 'Manage stages',
    etiquetas: 'Tags',
    conTodasLasEtiquetas: 'showing only those with all the selected tags',
  },

  etapas: {
    titulo: 'Funnel stages',
    ayuda: 'These are the columns of your board. You can rename them, change their colour and order them the way you work.',
    nombreNueva: 'Name of the new stage',
    entrada: 'entry',
    nombreEntrada: 'Hot Leads',
    ayudaEntrada: 'New leads land here. It cannot be renamed or deleted.',
    subir: 'Move up',
    bajar: 'Move down',
    color: 'Colour',
    borrarTitulo: 'Delete "{nombre}"',
    tieneContactos: 'This stage has {n} contact(s). Which stage should we move them to?',
    eligeEtapa: 'Choose a stage',
    estaVacia: 'The stage is empty. It will be deleted without moving anything.',
    errorCargar: 'Could not load the stages.',
    errorCrear: 'Could not create the stage.',
    errorRenombrar: 'Could not rename the stage.',
    errorColor: 'Could not change the colour.',
    errorOrden: 'Could not reorder.',
    errorBorrar: 'Could not delete the stage.',
  },

  notas: {
    titulo: 'Notes',
    lista: 'Note list',
    agregar: 'Add note',
    actualizar: 'Update note',
    favoritas: 'Favorites',
    etiquetas: 'Labels',
    personal: 'Personal',
    trabajo: 'Work',
    social: 'Social',
    importante: 'Important',
    campoTitulo: 'Title',
    campoDescripcion: 'Description',
    campoEtiqueta: 'Note label',
    phTitulo: 'Note title',
    phDescripcion: 'Note description',
    pideTitulo: 'Please enter a title',
    pideDescripcion: 'Please enter a description',
    confirmarBorrado: 'Are you sure you want to delete this note?',
  },

  tickets: {
    titulo: 'Tickets',
    tituloModal: 'Ticket',
    detalle: 'Ticket details',
    conversacion: 'Conversation',
    phMensaje: 'Type your message…',
    estado: 'Status',
    abierto: 'Open',
    pendiente: 'Pending',
    cerrado: 'Closed',
    colUsuario: 'User',
    colDescripcion: 'Description',
    colTipo: 'Type',
    colPrioridad: 'Priority',
    colEstado: 'Status',
    colCreado: 'Created date',
    colActualizado: 'Last updated',
    tipo_support: 'Support',
    tipo_payment: 'Payment',
    prioridad_high: 'High',
    prioridad_medium: 'Medium',
    prioridad_low: 'Low',
    estado_open: 'Open',
    estado_pending: 'Pending',
    estado_close: 'Closed',
    pideDescripcion: 'Please enter a description',
    actualizar: 'Update ticket',
    agregar: 'Create ticket',
  },

  panel: {
    titulo: 'Dashboard',
    resumenEmbudo: 'Pipeline overview',
    resumenTickets: 'Tickets overview',
    tarjetaContactos: 'Contacts',
    tarjetaSms: 'SMS',
    tarjetaCorreo: 'Emails',
    tarjetaTicketsAbiertos: 'Open tickets',
  },

  sesion: {
    salir: 'Sign out',
  },

  perfil: {
    miCuenta: 'My account',
    miPerfil: 'My profile',
    cambiarContrasena: 'Change password',
    miMarca: 'My branding',
    configuracion: 'Business setup',
    leadsFacebook: 'Facebook Leads',
    camposPropios: 'Contact fields',
    misDatos: 'My details',
    tuInformacion: 'Your personal information',
    identificacion: 'ID number',
    direccion: 'Address',
    rol: 'Role',
    contrasena: 'Password',
    cambiaLaContrasena: 'Change your account password',
    contrasenaActual: 'Current password',
    contrasenaNueva: 'New password',
    repiteLaNueva: 'Repeat the new one',
    minimo8: 'Minimum 8 characters',
    tuMarca: 'Your branding',
    ayudaMarca: 'Set your business name and logo. They will appear in the menu, the footer and the browser tab title, for you and for your whole team.',
    nombreDelNegocio: 'Business name',
    ejemploNegocio: 'e.g. Associates Rehab',
    logo: 'Logo',
    elegirImagen: 'Choose an image',
    formatoLogo: 'PNG, JPG or WEBP. 1 MB maximum.',
    quitarMiMarca: 'Remove my branding',
    redes: 'Social profiles',
    ayudaRedes: 'Add links to your profile',
  },

  // Conectar Facebook para recibir LEADS. Va aparte de `facebook`, que es la
  // conexion de Messenger: son dos apps de Meta distintas y dos flujos
  // distintos, y mezclar los textos haria que un cambio en uno tocara el otro.
  // Los campos a medida de la ficha del contacto. Nacen con los leads de
  // Facebook (un formulario puede preguntar «¿cuando se muda?»), pero sirven
  // para todo el CRM.
  camposPropios: {
    titulo: 'Contact fields',
    intro: 'Add the details your business needs to keep on every contact, beyond the ones that come built in. You can then fill them in by hand or pull them from your Facebook forms.',
    nuevo: 'New field',
    nuevoCampo: 'New field',
    editarCampo: 'Edit field',
    editar: 'Edit',
    etiqueta: 'Field name',
    ejemploEtiqueta: 'For example: Budget',
    llave: 'Key',
    tipo: 'Type',
    opciones: 'Options',
    ejemploOpciones: 'One option per line',
    nadaAun: 'You have not created any field yet.',
    guardado: 'Field saved.',
    borrado: 'Field deleted.',
    confirmarBorrar: 'This deletes the field and everything your contacts answered in it. Continue?',
    faltaEtiqueta: 'Give the field a name.',
    faltanOpciones: 'A list needs at least one option.',
    avisoLlave: 'You can rename this whenever you want: the key "{llave}" stays the same, and it is what keeps the link to your Facebook forms alive.',
    errorCargar: 'We could not load your fields.',
    errorGuardar: 'The field could not be saved.',
    errorBorrar: 'The field could not be deleted.',
    tipos: {
      text: 'Text',
      textarea: 'Long text',
      number: 'Number',
      date: 'Date',
      select: 'List',
      boolean: 'Yes / No',
    },
  },

  leadsFacebook: {
    titulo: 'Facebook Leads',
    intro: 'Connect your Facebook Page and the leads from your forms will land in your pipeline on their own, with nothing to download.',
    conectar: 'Connect Facebook',
    conectada: 'Page connected',
    desconectar: 'Disconnect',
    desconectada: 'Page disconnected.',
    confirmarDesconectar: 'Stop receiving leads from this Page?',
    nadaConectado: 'You have not connected a Page yet.',
    elegirPagina: 'Choose your Page',
    ayudaElegirPagina: 'These are the Pages you manage. Choose the one you want to receive leads from.',
    elegirFormulario: 'Which form?',
    ayudaElegirFormulario: 'If you do not pick one, you will get the leads from every form on that Page. That is the usual choice.',
    todosLosFormularios: 'All forms',
    ultimoLead: 'Last lead',
    sinLeadsAun: 'Connected. Waiting for the first lead.',
    sinSuscribir: 'Not subscribed',
    mapeo: 'Where each answer goes',
    ayudaMapeo: 'Choose where on the contact record you want to keep each answer from the form. Whatever you leave out is still saved in the lead detail.',
    editarMapeo: 'Fields',
    paraCambiar: 'To connect a different Page, disconnect the current one first.',
    enviarPrueba: 'Test',
    pruebaEnviada: 'Test lead sent',
    errorPrueba: 'The test lead could not be sent.',
    mapeoGuardado: 'Saved. The next leads will fill in these fields.',
    noGuardar: 'Do not save it anywhere',
    sinPreguntas: 'We could not read the questions on this form.',
    crearCampos: 'Missing a field? Create it in Contact fields',
    avisoSinMapeo: 'With all forms you cannot choose where each answer goes, because every form asks different things. Contact details are still recognised on their own.',
    errorMapeo: 'The setup could not be saved.',
    errorPreguntas: 'We could not read the questions on the form.',
    destinos: {
      first_name: 'First name',
      last_name: 'Last name',
      full_name: 'Full name',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      note: 'Contact note',
    },
    errorCargar: 'We could not load your connected Pages.',
    errorFormularios: 'We could not read the forms on that Page. You can still connect it and you will get them all.',
    errorDesconectar: 'The Page could not be disconnected.',
  },

  facebook: {
    conectar: 'Connect Facebook',
    canales: 'Channels',
    tusCanales: 'Your connected channels',
    sinCanalesConectados: 'You have no Page connected yet.',
    desconectar: 'Disconnect',
    desconectada: 'Page disconnected.',
    confirmarDesconexion: 'Disconnect “{nombre}”',
    avisoDesconexion: 'You will stop receiving that Page’s messages. You can connect it again whenever you want.',
    errorDesconectar: 'The Page could not be disconnected.',
    conectando: 'Connecting…',
    conectada: 'Page connected',
    elegirPagina: 'Choose your Page',
    ayudaElegir: 'You manage more than one Page. Choose the one you want to handle from here.',
    usarEsta: 'Use this one',
    yaConectada: 'Already connected',
    errorEntrar: 'Could not sign in with Facebook. Please try again.',
    errorConectar: 'The Page could not be connected.',
  },

  ficha: {
    verDetalle: 'Show technical detail',
    ocultarDetalle: 'Hide technical detail',
    idCampana: 'Campaign ID',
    idConjunto: 'Ad set ID',
    idAnuncio: 'Ad ID',
    idFormulario: 'Form ID',
    paginaEntrada: 'Landing page',
    referente: 'Referrer',
    guardarNota: 'Save note',
    camposPropios: 'Contact fields',
    no: 'No',
    etiquetas: 'TAGS',
    nuevaEtiqueta: '+ Tag',
    escribeEtiqueta: 'name and Enter',
    quitar: 'Remove',
    buscando: 'Searching…',
    nota: 'NOTE',
    ejemploNota: 'e.g. call in 8 days · very interested, urgent · does not answer in the morning',
    datos: 'DETAILS',
    editar: 'Edit',
    copiar: 'Copy',
    copiado: 'Copied!',
    registrado: 'Registered',
    etapa: 'STAGE',
    sinEtapa: 'No stage',
    llamar: 'Call',
    procedencia: 'Attribution',
    origen: 'Source',
    campana: 'Campaign',
    conjunto: 'Ad set',
    anuncio: 'Ad',
    formulario: 'Form',
    utmCampana: 'UTM campaign',
    comentario: 'Comment',
    direccion: 'Address',
    guardando: 'saving…',
    guardada: 'saved ✓',
    guardado: 'saved ✓',
    descartar: 'Discard',
    cerrar: 'Close',
  },

  tabla: {
    contactos: 'contacts',
    importar: 'Import',
    nuevoContacto: '+ New contact',
    nota: 'Note',
    confirmarBorrado: 'Are you sure you want to delete this contact?',
  },

  contacto: {
    nuevo: 'New contact',
    editar: 'Edit contact',
    cliente: 'Client',
    eligeCliente: 'Choose the client',
    nota: 'Note',
    phNota: 'E.g.: call in 8 days · very interested, urgent',
    telefonoConPrefijo: 'Phone (with +1)',
    guardarCambios: 'Save changes',
    crear: 'Create contact',
    pideNombre: 'Please enter the first name',
    pideApellido: 'Please enter the last name',
    pideCorreo: 'Please enter the email',
    pideDireccion: 'Please enter the address',
    pideTelefono: 'Please enter the phone number',
  },

  contactos: {
    titulo: 'Contacts',
  },
};
